import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { renderIconBySlug } from '../../../content/icons.js';
import { TooltipHtml } from '../../tooltip/tooltip.Html.js';

const PIN_COLOR_CLASS = {
  primary: 'text-primary',
  secondary: 'text-secondary',
  contrast: 'text-contrast',
  red: 'text-red',
  orange: 'text-orange',
  yellow: 'text-yellow',
  lime: 'text-lime',
  green: 'text-green',
  blue: 'text-blue',
  purple: 'text-purple',
  pink: 'text-pink',
};

const PIN_SIZE_VALUE = {
  sm: 18,
  md: 30,
  lg: 42,
};

export const BoardMapPinsLayer = ({
  pins,
  selectedPinId,
  selectedPinIds = [],
  linkedItemLabelsByPinId = {},
  onSelectPin,
  onPinPointerDown,
  onPinClick,
  onPinDoubleClick,
  offsetX = 0,
  offsetY = 0,
  getPinNodeId,
}) => (
  <>
    {pins.map(pin => {
      const iconSize = PIN_SIZE_VALUE[pin?.size] || PIN_SIZE_VALUE.md;
      const renderedIcon = pin?.iconSlug
        ? renderIconBySlug(pin.iconSlug, { size: iconSize })
        : null;
      const linkedItemLabel = linkedItemLabelsByPinId?.[pin.id] || null;
      const pinButton = (
        <button
          type='button'
          data-map-node-id={getPinNodeId?.(pin.id) || undefined}
          className={`-translate-x-1/2 -translate-y-full transition ${
            PIN_COLOR_CLASS[pin?.color] || 'text-secondary'
          } ${
            selectedPinId === pin.id || selectedPinIds.includes(pin.id)
              ? 'scale-110 opacity-100'
              : 'opacity-90'
          }`}
          onClick={event => {
            event.stopPropagation();
            onSelectPin?.(pin.id);
            onPinClick?.(pin);
          }}
          onPointerDown={event => onPinPointerDown?.(event, pin.id)}
          onDoubleClick={event => {
            event.stopPropagation();
            onPinDoubleClick?.(pin);
          }}
        >
          {renderedIcon ? (
            <span className='flex items-center justify-center'>
              {React.cloneElement(renderedIcon, {
                key: `${pin.id}-${pin.iconSlug || 'default'}`,
              })}
            </span>
          ) : (
            <FaMapMarkerAlt size={iconSize} />
          )}
        </button>
      );

      return (
        <div
          key={pin.id}
          className='absolute'
          style={{
            left: (Number(pin?.x) || 0) + offsetX,
            top: (Number(pin?.y) || 0) + offsetY,
            zIndex: 20,
          }}
        >
          {linkedItemLabel ? (
            <TooltipHtml title={linkedItemLabel}>{pinButton}</TooltipHtml>
          ) : (
            pinButton
          )}
        </div>
      );
    })}
  </>
);
